// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"745":"062bb0f98b8f7811","880":"1f038e2a1a9ddf31"}[chunkId] + ".js";
};